import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';

const AfterPurchaseExplanationModal = ({
    monthlyNumber,
    monthlyNumberFriendly,
    onHidden
}) => {
    return (
        <Modal
            className="AfterPurchaseExplanationModal"
            title="After you purchase"
            onHidden={onHidden}
        >
            <ModalContent>
                <p>After you check out, your parking pass will be emailed to you as well as available in your account. Make sure to read and follow the How To Redeem instructions on your parking pass before your reservation start date, then you are free to park.</p>
                <p>If you have any questions give us a call at <a href={`tel:${monthlyNumber}`}>{monthlyNumberFriendly}</a>.</p>
            </ModalContent>
        </Modal>
    );
};

AfterPurchaseExplanationModal.propTypes = {
    monthlyNumber: PropTypes.string.isRequired,
    monthlyNumberFriendly: PropTypes.string.isRequired,
    onHidden: PropTypes.func.isRequired
};

export default AfterPurchaseExplanationModal;
